const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// Obtener entregas con filtros
export const fetchEntregas = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/filter`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener entregas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchEntregas:', error);
    throw error;
  }
};

// Obtener solicitudes pendientes
export const fetchSolicitudesPendientes = async (filters = {}) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/solicitudes-pendientes`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(filters),
    });

    if (!response.ok) {
      throw new Error('Error al obtener solicitudes pendientes');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchSolicitudesPendientes:', error);
    throw error;
  }
};

// Alistar entrega
export const alistarEntrega = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/alistar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al alistar entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en alistarEntrega:', error);
    throw error;
  }
};

// Marcar como entregado
export const marcarComoEntregado = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/entregar`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al marcar como entregado');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en marcarComoEntregado:', error);
    throw error;
  }
};

// Obtener entrega por ID
export const fetchEntregaById = async (id) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/${id}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Error al obtener entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en fetchEntregaById:', error);
    throw error;
  }
};

// Cancelar entrega
export const cancelarEntrega = async (id, usuario, motivo) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/cancelar/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ usuario, motivo }),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al cancelar entrega');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en cancelarEntrega:', error);
    throw error;
  }
};

// Declinar solicitud
export const declinarSolicitud = async (data) => {
  try {
    const response = await fetch(`${API_URL}/entregas-insumos/declinar`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.message || 'Error al declinar solicitud');
    }

    return await response.json();
  } catch (error) {
    console.error('Error en declinarSolicitud:', error);
    throw error;
  }
};
